import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom, type PropsOf } from '@blaze-runtime/engine-domain';
type PdfViewerElement = CanvasElementFrom<'pdfViewer'>;
type PdfViewerProps = PartialDeep<PropsOf<'pdfViewer'>>;

function transformTextInputToPdfViewer(source: CanvasElementFrom<'textField'>): PdfViewerElement {
  const props: PartialDeep<PropsOf<'textField'>> = source.props || {};
  const newProps: PdfViewerProps = {
    content: {
      pdf: {
        downloadEnabled: true,
        printEnabled: true,
      },
      title: {
        enabled: props.content?.title?.enabled,
        label: props.content?.title?.label,
        align: props.content?.title?.align?.horizontal,
        icon: props.content?.title?.icon,
        iconPosition: props.content?.title?.iconPosition,
      },
    },
    style: {
      label: {
        color: props.style?.general?.title,
      },
      border: {
        outline: props.style?.input?.border,
        radius: props.style?.input?.radius,
      },
    },
  };

  // TODO: fix type
  return { props: newProps } as any;
}

function transformUploadFileToPdfViewer(source: CanvasElementFrom<'uploadFile'>): PdfViewerElement {
  const props: PartialDeep<PropsOf<'uploadFile'>> = source.props || {};
  const newProps: PdfViewerProps = {
    content: {
      pdf: {
        downloadEnabled: true,
        printEnabled: true,
      },
      title: {
        enabled: props.content?.title?.enabled,
        label: props.content?.title?.label,
        icon: props.content?.title?.icon,
        iconPosition: props.content?.title?.iconPosition,
      },
    },
    style: {
      label: {
        color: props.style?.general?.title,
      },
      border: {
        outline: props.style?.upload?.outline,
      },
    },
  };

  // TODO: fix type
  return { props: newProps } as any;
}

export const transformToPdfViewer = {
  transformTextInputToPdfViewer,
  transformUploadFileToPdfViewer,
};
